var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondaryDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 129,
    viewBox: "0 0 232 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0368A5",
    fillRule: "nonzero",
    d: "M33.794 14.263l-7.897 7.898V2.195C25.897.983 24.914 0 23.702 0c-1.212 0-2.195.983-2.195 2.195V22.16l-7.898-7.898c-.848-.848-2.224-.849-3.072 0-.849.847-.85 2.222-.001 3.07v.001l11.987 11.987c.651.651 1.706.651 2.357 0l11.987-11.987c.849-.848.849-2.223 0-3.07v-.001c-.849-.849-2.224-.848-3.073 0z",
    transform: "translate(-605 -192) translate(441 164) translate(164 28) translate(92.097) rotate(180 23.702 15.25)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0368A5",
    strokeWidth: 4.5,
    d: "M0 50.572c15.733 0 23.6-7.866 23.6-23.599M47.198 50.572c-15.732 0-23.599-7.866-23.599-23.599",
    transform: "translate(-605 -192) translate(441 164) translate(164 28) translate(92.097)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-605 -192) translate(441 164) translate(164 28) translate(150.097 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBFDFF",
    d: "M7 9.515l6.756-8.041h65.177c.588 0 1.065.477 1.065 1.065v115.01c0 .588-.477 1.064-1.065 1.064H1.065c-.588 0-1.065-.476-1.065-1.065V15.288l6.861-5.635c.05-.042.097-.088.14-.138z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.395,
    height: 2.319,
    x: 8.571,
    y: 24.868,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.614,
    height: 2.319,
    x: 8.571,
    y: 36.463,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.855,
    height: 2.319,
    x: 8.571,
    y: 43.421,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.614,
    height: 2.319,
    x: 8.571,
    y: 59.654,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.614,
    height: 2.319,
    x: 8.571,
    y: 66.611,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.855,
    height: 2.319,
    x: 8.571,
    y: 73.568,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 62.855,
    height: 2.319,
    x: 8.571,
    y: 80.525,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.595,
    height: 2.319,
    x: 8.117,
    y: 96.555,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.197,
    height: 2.319,
    x: 8.117,
    y: 103.512,
    fill: "#62A4D0",
    rx: 0.532
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4E6F2",
    d: "M13.653 1.354l.217 12.482c.013.716-.557 1.307-1.273 1.32L.12 15.372 13.653 1.354z",
    transform: "rotate(1 7.007 8.364)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-605 -192) translate(441 164) translate(164 28) translate(0 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.152,
    height: 119.022,
    fill: "#FBFDFF",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.083,
    height: 2.39,
    x: 29.034,
    y: 12.375,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.493,
    height: 2.39,
    x: 26.329,
    y: 17.786,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.642,
    height: 2.705,
    x: 8.231,
    y: 31.539,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.788,
    height: 2.39,
    x: 8.107,
    y: 38.71,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.813,
    height: 2.39,
    x: 8.231,
    y: 45.566,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.745,
    height: 2.39,
    x: 8.231,
    y: 57.203,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.788,
    height: 2.39,
    x: 8.107,
    y: 64.374,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.788,
    height: 2.39,
    x: 8.107,
    y: 71.545,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 8.231,
    y: 83.182,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 43.289,
    y: 83.182,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 8.231,
    y: 96.894,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 43.289,
    y: 96.894,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 8.231,
    y: 90.038,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 43.289,
    y: 90.038,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 8.231,
    y: 103.751,
    fill: "#62A4D0",
    rx: 0.561
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.756,
    height: 2.39,
    x: 43.289,
    y: 103.751,
    fill: "#62A4D0",
    rx: 0.561
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryDoc);
export default __webpack_public_path__ + "static/media/secondary-doc.74f0066112eea2bfdead75a1a26fc2ba.svg";
export { ForwardRef as ReactComponent };